<template>
  <div class="row columns">
    <div class="large-12">
      <div v-if="$store.getters.detailedRoster">
        <div class="row columns">
          <div class="large-12 inner-title">
            Joueurs de base:
          </div>
          <div class="large-12 inner-subtitle">
            Sélectionnez vos joueurs avec les bouton + / -
          </div>
        </div>
        <table>
          <thead>
          <tr class="">
            <th width="60"></th>
            <th width="150">
            </th>
            <th width="100">Prix</th>
            <th width="10">M</th>
            <th width="10">F</th>
            <th width="10">Ag</th>
            <th width="10">Cp</th>
            <th width="10">Ar</th>
            <th width="250">Compétences</th>
            <th with="200">Qté</th>
            <th with="150">coût total</th>
            <th width="20"></th>
            <th width="20"></th>
          </tr>
          </thead>
          <tbody class="roster" v-if="$store.getters.detailedRoster">
          <tr v-for="line of $store.getters.detailedRoster.roster_lines">
            <td>0-{{line.max}}</td>
            <td>{{line.position}}</td>
            <td>{{line.cost}} 000</td>
            <td>{{line.M}}</td>
            <td>{{line.F}}</td>
            <td>{{line.Ag}}+</td>
            <td>{{line.Cp}}+</td>
            <td>{{line.Ar}}+</td>
            <td>
               <span v-for="skill of line.base_skills">
                  {{skill.name}},
               </span>
            </td>
            <td>{{playerList[line.id]}}</td>
            <td>{{getLineCount(line) * line.cost }} 000</td>
            <td v-if="canAddLine(line)" class="action">
              <button class="action" v-on:click="addLine(line) ">+</button>
            </td>
            <td v-else class="action">
              <button :id="line.id" class="deactivated action" disabled>+</button>
            </td>
            <td v-if="playerList[line.id] && playerList[line.id] > 0">
              <button v-on:click="removeLine(line)" class="action" v-bind:id="line.id">-</button>
            </td>
            <td v-else>
              <button :id="line.id" class="deactivated action" disabled>-</button>
            </td>
          </tr>

          <tr>
            <td colspan="9" class="sous-total right">Budget Joueurs</td>
            <td class="sous-total">{{totalPlayer}}</td>
            <td class="sous-total">{{totalPlayerCost}} 000</td>
            <td colspan="2"></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'baseTeamBuilder',
  components: {
  },
  props: {
    roster: {},
    alreadyChosenLines: {}
  },
  data () {
    return {
      playerList: []
    }
  },
  computed:
  {
    getLineCount: function () {
      var vm = this
      return function (line) {
        if (vm.playerList[line.id]) {
          return vm.playerList[line.id]
        }
        return 0
      }
    },
    totalPlayer: function () {
      if (this.$store.getters.detailedRoster === null) {
        return 0
      }
      let totalPlayer = 0
      for (var line of this.$store.getters.detailedRoster.roster_lines) {
        if (this.playerList[line.id]) {
          totalPlayer += this.playerList[line.id]
        }
      }
      return totalPlayer
    },
    totalPlayerCost: function () {
      if (this.$store.getters.detailedRoster === null) {
        return 0
      }
      let totalPlayerCost = 0
      for (var line of this.$store.getters.detailedRoster.roster_lines) {
        if (this.playerList[line.id]) {
          totalPlayerCost += this.playerList[line.id] * line.cost
        }
      }
      return totalPlayerCost
    },
    totalPlayerCount: function () {
      let newPlayers = 0
      if (this.playerList.length > 0) {
        this.playerList.forEach(pType => {
          newPlayers = newPlayers + pType
        })
      }
      let oldPlayers = 0
      if (this.alreadyChosenLines.length > 0) {
        this.alreadyChosenLines.forEach(pType => {
          if (pType !== undefined) {
            oldPlayers = oldPlayers + pType
          }
        })
      }
      return newPlayers + oldPlayers
    }
  },
  methods: {
    // ajoute un joueur du type qui va bien
    addLine: function (line) {
      if (this.playerList[line.id] == null) {
        Vue.set(this.playerList, line.id, 1)
      } else {
        let newval = this.playerList[line.id] + 1
        Vue.set(this.playerList, line.id, newval)
      }
    },
    // enlève un joueur du type qui va bien
    removeLine (line) {
      if (this.playerList[line.id] == null) {
        return
      }
      if (this.playerList[line.id] > 0) {
        let newval = this.playerList[line.id] - 1
        Vue.set(this.playerList, line.id, newval)
      }
    },
    // peut-on enlever un joueur ?
    canRemoveLine: function (line) {
      if (this.playerList.length === 0) {
        return false
      }
      if (this.playerList[line.id] && this.playerList[line.id] > 0) {
        return true
      }
      return false
    },
    // peut-on ajouter un joueur ?
    canAddLine: function (line) {
      // console.log('alreadyChosenLine')
      // console.log(this.alreadyChosenLines)
      // console.log('playerList')
      if (!this.playerList[line.id]) {
        this.playerList[line.id] = 0
      }
      if (!this.alreadyChosenLines[line.id]) {
        this.alreadyChosenLines[line.id] = 0
      }
      let playerCount = this.playerList[line.id] + this.alreadyChosenLines[line.id]
      if (playerCount < line.max && this.totalPlayerCount < 16) {
        return true
      }
      return false
    },
    getPLayerArray () {
      let arr = []
      let playerNum = 1
      if (!this.$store.getters.detailedRoster) {
        return arr
      }
      for (let line of this.$store.getters.detailedRoster.roster_lines) {
        if (!this.playerList[line.id]) {
          continue
        }
        let cpt = this.playerList[line.id]
        for (let i = 0; i < cpt; i++) {
          let player = {}
          player.ref_roster_line = line.id
          player.num = playerNum
          playerNum++
          arr.push(player)
        }
      }
      return arr
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

.starbox {
  margin-bottom: 0;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 1.3rem;
  font-weight: 400;
}

.inner-subtitle{
  text-align: left;
  font-size: 0.8rem;
  font-weight: 300;
  margin-bottom: 0.3rem
}



.roster tr td.action{
    padding: 0.4rem 0.3rem;
}

button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
}
.note {
    font-weight: 100;
    font-size: 0.8rem;
}
.error {
  color:#E7505A;
}

</style>



// WEBPACK FOOTER //
// base-team-builder.vue?def47ea4